<template>
  <div id="app">
    <router-view />
    <LayoutLoading v-if="$store.state.LoadingShow" />
    <LayoutToast v-if="$store.state.ToastShow" :text="$store.state.ToastText" />
    <LayoutDialog
      v-if="$store.state.DialogShow"
      :dialogData="$store.state.DialogData"
    ></LayoutDialog>
  </div>
</template>
<script>
import "animate.css";
import LayoutLoading from "@/components/LayoutLoading.vue";
import LayoutToast from "@/components/LayoutToast.vue";
import LayoutDialog from "@/components/LayoutDialog.vue";
export default {
  data() {
    return {
      count: 0
    };
  },
  components: {
    LayoutLoading,
    LayoutToast,
    LayoutDialog
  },
  mounted() {
    this.$utils.rem();
  },
  methods: {
    confirmBack() {}
  },
  watch: {
    "$store.state.ToastShow": function(e) {
      if (e) {
        setTimeout(() => {
          this.$store.commit("ToastHide");
        }, 2000);
      }
    }
  }
};
</script>

<style lang="less">
@import "../../assets/icon.css";
@import "../../assets/app.less";

html,
body {
  height: 100%;
}

body {
  background: #f5f5f5;
}

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 0.3rem;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
  // font-family: RobotoRegular, Roboto-Medium, PingFang SC;
}

body {
  // max-width: 800px;
  // margin: 0 auto;
  font-size: 0.24rem;
}

img {
  display: block;
  margin: 0;
  padding: 0;
}
</style>
